<template>
    <div class="hello">
        <h3 v-on:click="return_to_cats()">{{ title }}</h3>
        <section v-if="errored">
            <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
        </section>
        <div v-if="loading" class="loading"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>

        <div v-if="(!showBrandProducts && !loading)"
             class="resultsblock">
            <div class='category row clearfix' v-for="category in processedCategories" v-bind:key="category.id">
                <div class='small-3 medium-2 large-1 columns'><a
                        v-on:click="get_brandproducts_by_category(category.id, category.name)"><img
                        :src="category.image" alt=''/></a>
                </div>
                <div class='small-9 medium-10 large-11 columns'><h5><a
                        v-on:click="get_brandproducts_by_category(category.id, category.name)">{{ category.name }}</a>
                    <span class='count'>({{ category.total_products  }} Items)</span></h5></div>
            </div>

        </div>
        <div id='resulttarget' v-if="(showBrandProducts && !loading)" class="productResults clearfix">
            <div class="resultsblock">
                <div class="row alphabrandpager cf">
                    Find results with brand names starting with:
                    <select v-model="alphaselect" name="alpha" class="alpha"
                            v-on:change="page = 1; get_brandproducts_by_category_and_alpha(cat_id, cat_name, alphaselect)">
                        <option value="">All</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                        <option value="E">E</option>
                        <option value="F">F</option>
                        <option value="G">G</option>
                        <option value="H">H</option>
                        <option value="I">I</option>
                        <option value="J">J</option>
                        <option value="K">K</option>
                        <option value="L">L</option>
                        <option value="M">M</option>
                        <option value="N">N</option>
                        <option value="O">O</option>
                        <option value="P">P</option>
                        <option value="Q">Q</option>
                        <option value="R">R</option>
                        <option value="S">S</option>
                        <option value="T">T</option>
                        <option value="U">U</option>
                        <option value="V">V</option>
                        <option value="W">W</option>
                        <option value="X">X</option>
                        <option value="Y">Y</option>
                        <option value="Z">Z</option>
                    </select>
                </div>

                <Pager v-if="(meta != null)" v-bind:meta="meta" @previous="previous_page()" @next="next_page()" v-bind:page="page"/>

                <BrandWithProducts
                        v-for="brandproduct in processedBrandProducts" v-bind:key="brandproduct.id"
                        v-bind:brandproduct="brandproduct" v-bind:cat_id="cat_id"
                        v-bind:totalshown="processedBrandProducts.length" />

                <Pager v-if="((meta != null) && (meta.total > 0))" v-bind:meta="meta" @previous="previous_page()" @next="next_page()" v-bind:page="page"/>
            </div>
        </div>
    </div>


</template>

<script>
    import BrandWithProducts from './BrandWithProducts.vue'
    import Pager from './Pager.vue'
    import ApiService from '../services/ApiService';

    export default {
        name: 'Categories',
        components: {
            BrandWithProducts,
            Pager
        },
        props: {
            componentKey: 0, // http://michaelnthiessen.com/force-re-render/
        },
        data() {
            return {
                alphaselect: '',
                title: "",
                categories: [],
                brandProducts: [],
                info: null,
                loading: true,
                errored: false,
                showBrandProducts: false,
                cat_id: false,
                cat_name: '',
                page: 0,
                meta: null
            }
        },
        created() {
            ApiService.getCategories().then(response => (this.categories = response.data))
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
                .finally(() => {
                    this.loading = false
                })
        },
        methods: {
            get_brandproducts_by_category(cat_id, cat_name) {
                this.loading = true;
                this.cat_id = cat_id;
                this.cat_name = cat_name;
                this.title = 'Brands and Products in Category "' + cat_name + '"';
                this.meta = null;
                // console.log('get products', cat_id);
                ApiService.getBrandproductsByCategory(cat_id, this.page)
                    .then(response => (this.brandProducts = response.data))
                    .then(response => (this.meta = response.meta))
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => {
                        this.showBrandProducts = true;
                        this.loading = false;
                    })
            },
            get_brandproducts_by_category_and_alpha(cat_id, cat_name, alphaselect) {
                if (alphaselect == '') {
                    this.get_brandproducts_by_category(cat_id, cat_name);
                } else {
                    this.cat_name = cat_name;
                    this.loading = true;
                    this.cat_id = cat_id;
                    this.meta = null;
                    this.title = 'Brands and Products in Category "' + cat_name + '" starting with "' + alphaselect + '"';
                    // console.log('get products', cat_id);
                    ApiService.getBrandproductsByCategoryAndAlpha(cat_id, alphaselect, this.page)
                        .then(response => (this.brandProducts = response.data))
                        .then(response => (this.meta = response.meta))
                        .catch(error => {
                            console.log(error);
                            this.errored = true
                        })
                        .finally(() => {
                            this.showBrandProducts = true;
                            this.loading = false;
                        })
                }
            },
            previous_page() {
                this.page--;
                this.get_brandproducts_by_category_and_alpha(this.cat_id, this.cat_name, this.alphaselect);
            },
            next_page() {
                this.page++;
                this.get_brandproducts_by_category_and_alpha(this.cat_id, this.cat_name, this.alphaselect);
            },
            return_to_cats() {
                this.showBrandProducts = false;
            }
        },
        computed: {
            processedCategories() {
                if ('undefined' != this.categories) {
                    // console.log('in processed', this.categories.data);
                    let categories = this.categories.data;
                    categories.map(category => {
                        category.image = category.image_url ? category.image_url : "";
                    });
                    return categories;
                } else {
                    return [];
                }
            },
            processedBrandProducts() {
                if ('undefined' != this.brandProducts) {
                    let brandProducts = this.brandProducts.data;
                    // console.log('here', brandProducts);
                    return brandProducts;
                } else {
                    return [];
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        font-size: 24px;
        font-weight: 500;
        margin: 40px 0 0;
    }

    h5 a {
        color: #555;
    }


    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .alphabrandpager {
        text-align: center !important;
        padding: .5em 0;
    }
</style>
